import { defineMessages } from 'react-intl'


export default defineMessages({
  notice: {
    defaultMessage: 'For provider details, see our <link>Legal Notice</link>.',
    description: 'The German translation of "Legal Notice" must be "Impressum" (the legally required term under §5 TMG).',
    id: 'impressum-link.notice',
  },
})
